import axiosInstance from "../axiosInstance";

export const agentConfigService = {
  create: async (data) => {
    try {
      const response = await axiosInstance.post("/agent-config", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (searchValue, query, type) => {
    try {
      let api_query = `/agent-config?`;
      if (searchValue?.trim()) {
        api_query += `${type || "name"}[$search]=${searchValue.trim()}`;
      }
      if (query?.length) {
        api_query += `${searchValue?.trim() ? "&" : ""}${query}`;
      }
      const response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async (id) => {
    try {
      const response = await axiosInstance.get(`/agent-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id) => {
    try {
      const response = await axiosInstance.patch(`/agent-config/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/agent-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
